/** @format */

import {
    SimCardServiceGroupCollection,
    SimCardServiceTypeAllowedParamCollection,
    SimCardServiceTypeCollection,
    SimCardServiceTypeItem,
} from '../../interfaces/collections/SimCardServiceInterface';
import { SimCardServiceTemplateCollection } from '../../interfaces/platform/SimCardServiceTemplate';

export const ServicesAction = {
    FEATURES_LOAD_SIM_CARD_SERVICE_GROUP_LIST: 'FEATURES_LOAD_SIM_CARD_SERVICE_GROUP_LIST',
    FEATURES_LOAD_SIM_CARD_SERVICE_GROUP_LIST_LOAD: 'FEATURES_LOAD_SIM_CARD_SERVICE_GROUP_LIST_LOAD',
    FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_LIST: 'FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_LIST',
    FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_LIST: 'FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_LIST',

    FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_RELOAD: 'FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_RELOAD',
    FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_OPEN: 'FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_OPEN',
    FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT: 'FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_OPEN',

    FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_RELOAD_AFTER_EDIT: 'FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_RELOAD_AFTER_EDIT',
    FEATURES_LOAD_SIM_CARD_SERVICE_TEMPLATE_LIST: 'FEATURES_LOAD_SIM_CARD_SERVICE_TEMPLATE_LIST',
};

export type FeaturesServiceReducerType = {
    type: string;
    serviceList?: SimCardServiceTypeCollection;
    serviceTemplateList?: SimCardServiceTemplateCollection;
    serviceGroupList?: SimCardServiceGroupCollection;
    simCardServiceType?: SimCardServiceTypeItem;
    simCardServiceTypeAllowedParamsCollection?: SimCardServiceTypeAllowedParamCollection;
    openEdit?: boolean;
    reload?: boolean;
};

export type FeaturesServiceGroupReducerType = {
    type: string;
    serviceGroupList?: SimCardServiceGroupCollection;
};

export const serviceReducer = (state: any, params: FeaturesServiceReducerType | FeaturesServiceGroupReducerType): object => {
    switch (params.type) {
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_RELOAD_AFTER_EDIT:
            return {
                ...state,
                ...params,
            };
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT:
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_GROUP_LIST:
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_LIST:
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_RELOAD:
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_OPEN:
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_LIST:
        case ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TEMPLATE_LIST:
        default:
            return {
                ...state,
                ...params,
                reload: false,
            };
    }
};
